import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { ConvertService } from 'src/app/services/convert.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { FireValidatorsService } from 'src/app/services/fire-validators.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { ITrending } from 'src/app/interfaces/book-store';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';

@Component({
  selector: 'app-trending-form',
  templateUrl: './trending-form.component.html',
  styleUrls: ['./trending-form.component.scss']
})
export class TrendingFormComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  ITEM_KEY: any;
  ITEM: any;
  TITLE: any = "Add new trending"
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthStore,
    public store: BookstoreStore,
    public ds: DataService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), null, COLLECTION_NAME.BOOK_STORE_TRENDING, "name")],
      description: [null],
    })
    this.route.params.subscribe(param => {
      const { id } = param;
      if (id !== 'draft') {
        this.ITEM_KEY = param.id;
        this.store.fetchSelectedData(COLLECTION_NAME.PROGRAM, this.ITEM_KEY, (doc: any) => {
          if (doc) {
            this.TITLE = "Edit trending"
            this.ITEM = doc;
            this.form = this.fb.group({
              name: [null, Validators.required, FireValidatorsService.checkExistByCompany(this.ds.firestoreRef(), null, COLLECTION_NAME.BOOK_STORE_TRENDING, "name", this.ITEM.name)],
              description: [null],
            })
            const { name, description } = doc;
            this.form.patchValue({
              name, description
            })
            this.inputEl.nativeElement.focus();
            return;
          }
          else {
            this.ITEM = null;
            this.router.navigate([`/book-store/trending`])
          }
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
      }
    })
  }

  onSave(f: any, isDraft: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    if (this.form.valid) {
      this.form.disable();
      const { name, description } = f;
      const { user } = this.auth;
      const registerStatus = isDraft ? STATUS_OBJECT.draft : STATUS_OBJECT.submitted;
      const item: ITrending = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${name.trim()}`),
        organizationRef: null,
        organizationKey: null,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name.trim(),
        description
      }
      this.store.addItem(COLLECTION_NAME.BOOK_STORE_TRENDING, item, (success, res) => {
        if (success) {
          this.snackBar.open("Trending has been saved successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (this.ITEM_KEY) {
          this.router.navigate([`/book-store/trending/submitted`])
        }
      })
    }
    else {
      this.inputEl.nativeElement.focus();
      this.processNew = false;
      this.processClose = false;
    }
  }

  goBack() {
    this.router.navigate([`/book-store/trending/submitted`])
  }

}
